import { getNativeConfig } from 'src/config/brandings/bid/nativeConfig.ts'

module.exports = () => {
  return {
    app_name: 'Bildung im Dialog',
    styles: {
      load: () => import(/* webpackChunkName: "styleBID" */'src/config/brandings/bid/index.scss')
    },
    meta: {
      meta: [
        { name: 'apple-itunes-app', content: 'app-id=6443700937' },
        { name: 'og:image', content: '/brandings/bid/favicons/favicon-192x192.png' },
        { name: 'twitter:image', content: '/brandings/bid/favicons/favicon-192x192.png' }
      ],
      link: [
        { rel: 'shortcut icon', href: '/brandings/bid/favicons/favicon-32x32.png', type: 'image/png' }
      ]
    },
    logos: {
      logo: 'brandings/bid/logo/bid-logo.svg'
    },
    search: {
      queries: {
        branding: 'BID'
      }
    },
    start: {
      description: 'public.start.security',
      image: false,
      show_more: false,
      sdui_authenticator: true
    },
    management: {
      show_announcements: false,
      show_material_page: false,
      additional_content: {
        infos: 'branding.bid.management.additional_content.infos'
      }
    },
    ui: {
      show_hint_cards: true,
      show_video_hint: false
    },
    settings: {
      notifications: {
        email_newsletter: false
      }
    },
    dataProtection: {
      show_go_to_sdui_website: false
    },
    onboarding: {
      help_videos: false
    },
    keepAlivePing: false,
    appSwitcher: {
      show_marketing: false
    },
    login: {
      registration_code: true,
      hideSduiLoginDefault: false,
      sduiLoginDefaultExpanded: false,
      form: {
        inline_reset_password: true
      }
    },
    ...getNativeConfig()
  }
}
